import React, { useEffect, useState } from 'react';
import { LinePlaceholder } from './LinePlaceholder';

/**
 * Recursively collects all descendant bin rows from a node.
 * Used by SiteSummary components in account-level group rows (aggregated view)
 * where direct children are site rows, not bin rows.
 */
export const getAllDescendantBinData = (node: any): any[] => {
  if (!node || !node.childrenAfterFilter) return [];
  const result: any[] = [];
  for (const child of node.childrenAfterFilter) {
    if (child.data && child.data.grain_bin_id !== undefined) {
      result.push(child.data);
    } else {
      result.push(...getAllDescendantBinData(child));
    }
  }
  return result;
};

const SiteDetails = (props) => {
  const { node } = props;
  const [expanded, setExpanded] = useState(node.expanded);

  useEffect(() => {
    const expandListener = (event) => setExpanded(event.node.expanded);

    node.addEventListener('expandedChanged', expandListener);

    return () => {
      node.removeEventListener('expandedChanged', expandListener);
    };
  }, []);

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {expanded ? <LinePlaceholder /> : props.children}
    </div>
  );
};

const SiteDetailsWithoutPlaceholder = (props) => {
  const { node } = props;
  const [expanded, setExpanded] = useState(node.expanded);

  useEffect(() => {
    const expandListener = (event) => setExpanded(event.node.expanded);

    node.addEventListener('expandedChanged', expandListener);

    return () => {
      node.removeEventListener('expandedChanged', expandListener);
    };
  }, []);

  if (expanded) return null;

  return (
    <div
      style={{
        display: 'flex',
        paddingRight: 5,
        paddingLeft: 10,
      }}
    >
      {props.children}
    </div>
  );
};

export { SiteDetails, SiteDetailsWithoutPlaceholder };
